import { render, staticRenderFns } from "./lc-editor-info.vue?vue&type=template&id=12b1a0a8"
import script from "./lc-editor-info.vue?vue&type=script&lang=js"
export * from "./lc-editor-info.vue?vue&type=script&lang=js"
import style0 from "./lc-editor-info.vue?vue&type=style&index=0&id=12b1a0a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports